import * as React from "react";

//MUI
import {
  Box,
  Fade,
  Tooltip,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Check } from "@mui/icons-material";

// Constants
import { terracotta, disabledText } from "Constants/ColourConstants";

// Customize the connector
const ColorfulConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 18,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: terracotta,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: terracotta,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const CustomStepIconRoot = styled("div")(({ _, ownerState }) => ({
  backgroundColor: disabledText,
  zIndex: 1,
  color: "#fff",
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontSize: 16,
  ...(ownerState.active && {
    backgroundColor: terracotta,
  }),
  ...(ownerState.completed && {
    backgroundColor: terracotta,
  }),
}));

function CustomStepIcon(props) {
  const { active, completed, className, icon } = props;
  return (
    <CustomStepIconRoot
      ownerState={{ active, completed }}
      className={className}
    >
      {completed ? <Check fontSize="inherit" /> : icon}
    </CustomStepIconRoot>
  );
}

const MNStepper = ({ steps, activeStep, onStepClick, latestStepCompleted }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Fade in timeout={600} key={steps.length + steps.join("-")}>
        <div>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            connector={<ColorfulConnector />}
          >
            {steps.map((label, index) => {
              const isClickable = index <= latestStepCompleted && onStepClick;

              const stepLabel = (
                <StepLabel
                  StepIconComponent={CustomStepIcon}
                  onClick={isClickable ? () => onStepClick(index) : undefined}
                  sx={{
                    cursor: isClickable ? "pointer" : "default",
                    pointerEvents: isClickable ? "auto" : "none",
                  }}
                >
                  {label}
                </StepLabel>
              );

              return (
                <Step key={label}>
                  {isClickable ? (
                    <Tooltip title={`Go to ${label} step`} arrow>
                      {stepLabel}
                    </Tooltip>
                  ) : (
                    stepLabel
                  )}
                </Step>
              );
            })}
          </Stepper>
        </div>
      </Fade>
    </Box>
  );
};

export default MNStepper;
